import { render, staticRenderFns } from "./imageTxtStyle.vue?vue&type=template&id=53127afa&scoped=true"
import script from "./imageTxtStyle.vue?vue&type=script&lang=js"
export * from "./imageTxtStyle.vue?vue&type=script&lang=js"
import style0 from "./imageTxtStyle.vue?vue&type=style&index=0&id=53127afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53127afa",
  null
  
)

export default component.exports